module.exports = __webpack_public_path__ + "images/emoji/mountain_railway.61b98b957ee3c8b5b725.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mountain_railway.png
// module id = y4Yq
// module chunks = 13